module.exports = {
          srcSet: __webpack_public_path__ + "8d84edb7790ad4190017067dacb70f37-160.png"+" 160w",
          images:[ {path: __webpack_public_path__ + "8d84edb7790ad4190017067dacb70f37-160.png",width: 160,height: 160}],
          src: __webpack_public_path__ + "8d84edb7790ad4190017067dacb70f37-160.png",
          toString:function(){return __webpack_public_path__ + "8d84edb7790ad4190017067dacb70f37-160.png"},
          
          width: 160,
          height: 160
        }